import { render, staticRenderFns } from "./tableServiceType.vue?vue&type=template&id=198962cc&scoped=true&"
import script from "./tableServiceType.vue?vue&type=script&lang=js&"
export * from "./tableServiceType.vue?vue&type=script&lang=js&"
import style0 from "./tableServiceType.vue?vue&type=style&index=0&id=198962cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198962cc",
  null
  
)

export default component.exports